import React, {useContext, useEffect, useState} from "react";
import {isEmpty} from "../Utils";
import {toggleModal} from "../../actions/modal.action";
import {useHistory} from "react-router";
import {MyContext} from "../../contexts/MyContext";
import {useDispatch, useSelector} from "react-redux";

const Rating = ({video}) => {
    const history = useHistory()
    const dispatch = useDispatch()
    const { rootState, setVideoRating } = useContext(MyContext);
    const { isAuth } = rootState;
    const [isHasVote, setIsHasVote] = useState(0);
    const translations = useSelector(
        (state) => state.langReducer.translationsReducer.translate
    );

    useEffect(() => {
        setIsHasVote(parseInt(video.is_has_vote));
    }, [video?.is_has_vote]);

    const handleRating = (stars) => {
        const setRating = async () => {
            if (isAuth) {
                await setVideoRating(video.id, stars)
                    .then((res) => {
                        if (res.result === "ok") {
                            setIsHasVote(stars);

                            let	text = translations && !isEmpty(translations["thank_for_vote"])
                                ? translations["thank_for_vote"]
                                : "Thank you for your vote"

                            dispatch(toggleModal({opened: true, success: true, text: text}))
                        }
                    })
            } else {
                history.push("/account/login");
            }

        };
        if (isHasVote !== stars) {
            setRating();
        }
    };

    return (
        <div className="stars">
            <input readOnly type="radio" id="star5" name="star5" value="5"
                   checked={parseInt(video.stars) >= 5}
                   onClick={() => handleRating(5)}
            />
            <label htmlFor="star5" title="5 stars">5 stars</label>

            <input readOnly type="radio" id="star4" name="star4" value="4"
                   checked={parseInt(video.stars) >= 4}
                   onClick={() => handleRating(4)}
            />
            <label htmlFor="star4" title="4 stars">4 stars</label>

            <input readOnly type="radio" id="star3" name="star3" value="3"
                   checked={parseInt(video.stars) >= 3}
                   onClick={() => handleRating(3)}
            />
            <label htmlFor="star3" title="3 stars">3 stars</label>

            <input readOnly type="radio" id="star2" name="star2" value="2"
                   checked={parseInt(video.stars) >= 2}
                   onClick={() => handleRating(2)}
            />
            <label htmlFor="star2" title="2 stars">2 stars</label>

            <input readOnly type="radio" id="star1" name="star1" value="1"
                   checked={parseInt(video.stars) >= 1}
                   onClick={() => handleRating(1)}
            />
            <label htmlFor="star1" title="1 star">1 star</label>
        </div>
    )
}

export default Rating